import { Link, useNavigate, useLocation } from "react-router-dom";
// Static site images should use direct public folder references
// import { getImageUrl } from "@/config/storage";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== "/") {
      navigate("/#" + sectionId);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="bg-gray-50 border-t">
      <div className="container mx-auto px-6 py-4">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 text-xs">
          <div className="space-y-1">
            <h3 className="font-semibold text-xs uppercase tracking-wider text-gray-700">
              About
            </h3>
            <img
              src="/aig_consulting_logos_v4_lightLogoFull.png"
              alt="AI Genius Automations"
              className="h-8 my-1"
              loading="lazy"
            />
            <p className="text-[10px] text-gray-600">AI-Empowered Businesses</p>
          </div>

          <div className="space-y-1">
            <h3 className="font-semibold text-xs uppercase tracking-wider text-gray-700">
              Links
            </h3>
            <ul className="space-y-0.5">
              <li>
                <Link
                  to="/"
                  className="text-gray-600 hover:text-[#9b87f5] transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("pricing")}
                  className="text-gray-600 hover:text-[#9b87f5] transition-colors"
                >
                  Pricing
                </button>
              </li>
            </ul>
          </div>

          <div className="space-y-1">
            <h3 className="font-semibold text-xs uppercase tracking-wider text-gray-700">
              Services
            </h3>
            <ul className="space-y-0.5">
              <li>
                <Link
                  to="/calendar"
                  className="text-gray-600 hover:text-[#9b87f5] transition-colors"
                >
                  Event Calendar
                </Link>
              </li>
              <li>
                <Link
                  to="/tools"
                  className="text-gray-600 hover:text-[#9b87f5] transition-colors"
                >
                  Tools
                </Link>
              </li>
            </ul>
          </div>

          <div className="space-y-1">
            <h3 className="font-semibold text-xs uppercase tracking-wider text-gray-700">
              Legal
            </h3>
            <ul className="space-y-0.5">
              <li>
                <Link
                  to="/terms"
                  className="text-gray-600 hover:text-[#9b87f5] transition-colors"
                >
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-gray-600 hover:text-[#9b87f5] transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          <div className="space-y-1">
            <h3 className="font-semibold text-xs uppercase tracking-wider text-gray-700">
              Contact
            </h3>
            <ul className="space-y-0.5">
              <li>
                <Link
                  to="/contact"
                  className="text-gray-600 hover:text-[#9b87f5] transition-colors"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-3 pt-3 text-center">
          <p className="text-[10px] text-gray-500">
            © {new Date().getFullYear()} AI Genius Automations. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
